import { Link } from 'react-router-dom'; 
import React, { Component } from 'react';

class Nochesdeterror extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2> Noches de terror en Dinoparque</h2>
          </header>
          <div className="containerimagenblog">
          <img className="imagenBlog" src="images/Blog/portadaterror.jpg" alt="Noches de Terror 2025" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                  Las Noches de Terror en Dinoparque fueron todo un éxito.
                  </p>
                  <p>
                  Ayer cerramos esta experiencia espeluznante y divertida con más de 700 valientes que se atrevieron a vivir la última noche del terror.
                  </p>
                <p>Familias completas disfrutaron de las casas temáticas, los efectos audiovisuales y la ambientación que transformó el parque en un verdadero recorrido del miedo.
                    En total, más de 1,200 asistentes nos acompañaron durante los dos días.
                    Nos llena de alegría saber que, año con año, seguimos creando momentos que nuestros visitantes disfrutan y recuerdan con emoción.
                </p>
                <b>
                  ¡Nos vemos muy pronto en el Dinoparque Iluminado!
                </b>
            </div>
            <div className="containerimagenBlogmini"> 
              <img className="imagenBlogmini" src="images/Blog/nochesterror1.jpg" alt="Noches de Terror 2025" />
              <img className="imagenBlogmini" src="images/Blog/nochesterror2.jpg" alt="Noches de Terror 2025" />
              <img className="imagenBlogmini" src="images/Blog/nochesterror3.jpg" alt="Noches de Terror 2025" />
            </div>
            <div>
              <div className="containerjuego">
              <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default Nochesdeterror;